import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReviewInputInformationsComponent } from 'src/app/core/common/components/review-input-informations/review-input-informations.component';
import { ReviewSelectedChallangesComponent } from 'src/app/core/common/components/review-selected-challanges/review-selected-challanges.component';
import { ReviewSelectedSolutionsComponent } from 'src/app/core/common/components/review-selected-solutions/review-selected-solutions.component';
import { PARAMS } from 'src/app/core/common/constants/routes.constant';
import { DiagnosisSummaryViewComponent } from './diagnosis-summary-view/diagnosis-summary-view.component';

@Component({
  selector: 'app-diagnosis-summary-view-container',
  imports: [
    ReviewSelectedChallangesComponent,
    ReviewInputInformationsComponent,
    ReviewSelectedSolutionsComponent,
    DiagnosisSummaryViewComponent,
  ],
  templateUrl: './diagnosis-summary-view-container.component.html',
  styleUrl: './diagnosis-summary-view-container.component.scss',
})
export class DiagnosisSummaryViewContainerComponent implements OnInit {
  readonly #activeRoute = inject(ActivatedRoute);
  sessionId = '';

  ngOnInit(): void {
    this.#activeRoute.paramMap.subscribe((params) => {
      this.sessionId = params.get(PARAMS.SessionId)!;
    });
  }
}
